import { render, staticRenderFns } from "./OrganizationWelcome.vue?vue&type=template&id=4c4abd4b&lang=pug"
import script from "./OrganizationWelcome.vue?vue&type=script&lang=js"
export * from "./OrganizationWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports